
import { defineComponent } from "vue";
import { IAcademicCompetenciesModel } from "@/interfaces/modules";
import AcademicCompetenciesService from "@/api/AcademicBase/AcademicCompetenciesService";
import router from "@/router";

export default defineComponent({
  name: "AcademicCompetenciesContent",
  data() {
    return {
      form: {
        dialog: false,
        record: {} as IAcademicCompetenciesModel,
      },
      table: {
        filters: { search: "" },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "TeacherName", label: "Docente", sortable: true },
          { key: "SubjectName", label: "Asignatura", sortable: true },
          { key: "SaberTypeName", label: "Saber", sortable: true }, // Hacer / Saber / Ser
          { key: "Title", label: "Título de la competencia", sortable: true },
          { key: "WeightPercent", label: "Peso %", sortable: true },
          { key: "AcademicYearName", label: "Año académico", sortable: true },
          { key: "EnableFormat", label: "Estado", sortable: false },
          { key: "CreatedByFormat", label: "Creación", sortable: true },
          { key: "ModifiedByFormat", label: "Última modificación", sortable: true },
          { key: "action", label: "Acciones", sortable: false },
        ],
        records: [] as IAcademicCompetenciesModel[],
        rowsPerPage: 10,
      } as any,
    };
  },
  async mounted() {
    await this.load();
  },
  computed: {
    filteredItems(): IAcademicCompetenciesModel[] {
      const search = this.table.filters.search?.toLowerCase() || "";

      if (!search) {
        return this.table.records;
      }

      return this.table.records.filter((item: any) => {
        return (
          item.TeacherName?.toLowerCase().includes(search) ||
          item.SubjectName?.toLowerCase().includes(search) ||
          item.SaberTypeName?.toLowerCase().includes(search) ||
          item.Title?.toLowerCase().includes(search) ||
          item.DisplayCode?.toLowerCase().includes(search) ||
          item.AcademicYearName?.toLowerCase().includes(search) ||
          String(item.WeightPercent ?? "").toLowerCase().includes(search)
        );
      });
    },
    rows(): number {
      return this.table.records?.length || 0;
    },
  },
  methods: {
    async load() {
      this.table.loading = true;
      try {
        // Ajusta el nombre del método si tu servicio usa otro (GetAll, GetByFilter, etc.)
        this.table.records = await AcademicCompetenciesService.GetAcademicCompetencies();
      } finally {
        this.table.loading = false;
      }
    },
    openForm(Id: any) {
      // Ajusta la ruta según tu configuración real
      router.push(`/base-academic/competencies-tab-content/${Id}`);
    },
  },
});
